import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import HTML_MAX_LENGTH = Constants.HTML_MAX_LENGTH
import { authActions } from '../auth/auth.actions'
import { AppState } from '../core.state'
import { NotificationService } from '../notification.service'
import { Constants } from 'src/app/shared/constants'
import { BsModalService } from 'ngx-bootstrap/modal'
import { EditorModalComponent } from 'src/app/shared/components/editor-modal/show.component'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private modalService: BsModalService,
    private notificationService: NotificationService,
    private router: Router,
    private store: Store<AppState>
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const errors = err?.error?.message || err?.statusText

        console.error(errors, err.status)

        switch (err.status) {
          case 401:
            if (errors != 'Refresh token expired') {
              console.log('401 error, will attempt token refresh')
              this.store.dispatch(authActions.onUnauthorizedTokenRefresh())
            }
            break
          case 400:
          case 403:
            if (errors && errors instanceof Array && errors.length) {
              errors.map((x) => {
                if (typeof x == 'string') {
                  this.notificationService.emit(x, 'warning')
                }
                Object.values(x.constraints).map((constraint) =>
                  this.notificationService.emit(
                    constraint.toString(),
                    'warning'
                  )
                )
              })
            } else if (errors) {
              if (errors.includes(`values cannot exceed ${HTML_MAX_LENGTH}`)) {
                const modalRef = this.modalService.show(EditorModalComponent, {
                  class:
                    'modal-sm modal-dialog-centered modal-dialog-scrollable '
                })
              }
              this.notificationService.emit(errors.toString(), 'warning')
            } else {
              this.notificationService.emit('alerts.badRequest', 'warning')
            }
            break
          default:
            this.notificationService.emit(errors ?? 'alerts.error', 'error')
            this.store.dispatch(authActions.onErrorFailed())
            break
        }

        return throwError(err)
      })
    )
  }
}
